import { render, staticRenderFns } from "./section-size.vue?vue&type=template&id=16e960b9&scoped=true&"
import script from "./section-size.vue?vue&type=script&lang=js&"
export * from "./section-size.vue?vue&type=script&lang=js&"
import style0 from "./section-size.vue?vue&type=style&index=0&id=16e960b9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16e960b9",
  null
  
)

export default component.exports